import { CONFIG_SUCCESS, CONFIG_ERROR, CONFIG_LOADING } from 'helpers/types';

const STORAGE_FEATURES = 'features';

const storage = {
  features: sessionStorage.getItem(STORAGE_FEATURES),
};

const INITIAL_STATE = {
  features: storage.features === null || storage.features === 'undefined' ? {} : JSON.parse(storage.features),
  error: false,
  loading: false,
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case CONFIG_SUCCESS:
      sessionStorage.setItem(STORAGE_FEATURES, JSON.stringify(action.payload.features));
      return {
        features: action.payload.features,
        error: false,
        loading: false,
      };
    case CONFIG_ERROR:
      return {
        features: {},
        error: action.payload,
        loading: false,
      };
    case CONFIG_LOADING:
      return {
        features: {},
        error: false,
        loading: true,
      };
    default:
      return state;
  }
}
